export default __webpack_public_path__ + "static/media/attorney_1_small.885d1b24.png";